/**
 * SIM di una pratica Fastweb (bundle F+M o fisso con SIM): ogni SIM diventa una pratica CRM collegata alla principale,
 * e su Teamwork una pratica dello stesso gruppo. Il collegamento sta nei dati portale (chiavi lette anche dal backend).
 */
export const MAIN_PRACTICE_KEY = 'PRATICA_PRINCIPALE'
export const LINKED_PRACTICES_KEY = 'PRATICHE_COLLEGATE'

export interface SimLine {
  productId: string
  /** NUOVA (nuova SIM) o PORTABILITA (numero da un altro gestore). */
  attivazione: string
  numero: string
  gestore: string
  /** ABBONAMENTO o RICARICABILE. */
  membership: string
  iccid: string
}

export const EMPTY_SIM: SimLine = { productId: '', attivazione: 'NUOVA', numero: '', gestore: '', membership: 'ABBONAMENTO', iccid: '' }

export const isBundle = (name: string | undefined) => /BUNDLE\s*F\s*\+\s*M/i.test(name ?? '')
export const isMobileProduct = (name: string | undefined) => /MOBILE|\bSIM\b/i.test(name ?? '')

/** Errori che impediscono il salvataggio (bundle senza fisso o senza SIM, SIM incomplete). Vuoto = va bene. */
export function simErrors(mainProductName: string | undefined, sims: SimLine[], productName: (id: string) => string | undefined): string[] {
  const errors: string[] = []
  const mainBundle = isBundle(mainProductName)
  const mainMobile = isMobileProduct(mainProductName)
  const simBundle = sims.some(s => isBundle(productName(s.productId)))
  if (mainBundle && mainMobile) errors.push('In un bundle F+M il prodotto principale è il fisso: le SIM si aggiungono nella sezione SIM.')
  else if (mainBundle && !sims.some(s => isBundle(productName(s.productId))))
    errors.push('Un bundle F+M richiede almeno una SIM con un prodotto Mobile BUNDLE F+M.')
  if (simBundle && !(mainBundle && !mainMobile)) errors.push('Le SIM BUNDLE F+M vanno con un fisso BUNDLE F+M come prodotto principale.')
  sims.forEach((s, i) => {
    const n = i + 1
    if (!s.productId) errors.push(`SIM ${n}: scegli il prodotto.`)
    else if (!isMobileProduct(productName(s.productId))) errors.push(`SIM ${n}: il prodotto deve essere un'offerta Mobile.`)
    if (s.attivazione === 'PORTABILITA' && !s.numero.trim()) errors.push(`SIM ${n}: indica il numero da portare.`)
    if (s.attivazione === 'PORTABILITA' && !s.gestore.trim()) errors.push(`SIM ${n}: indica il gestore di provenienza.`)
  })
  return errors
}

/** Campi del fisso che non valgono per la SIM. */
const FIXED_ONLY = ['TECNOLOGIA', 'TIPO_LINEA', 'TIPO_ATTIVAZIONE', 'NUMERO_DA_PORTARE', 'OPERATORE_ATTUALE', 'CODICE_MIGRAZIONE',
  'SERIALE_SIM', LINKED_PRACTICES_KEY]

/** Dati portale della pratica SIM: anagrafica, indirizzi e pagamento della principale più i dati della SIM. */
export function simPortalData(mainPortal: Record<string, string>, sim: SimLine, mainId: number): Record<string, string> {
  const out: Record<string, string> = {}
  for (const [k, v] of Object.entries(mainPortal)) if (!FIXED_ONLY.includes(k) && v.trim()) out[k] = v.trim()
  out['TIPO_LINEA'] = 'MOBILE'
  out['TIPO_ATTIVAZIONE'] = sim.attivazione
  if (sim.attivazione === 'PORTABILITA') {
    out['NUMERO_DA_PORTARE'] = sim.numero.trim()
    out['OPERATORE_ATTUALE'] = sim.gestore.trim()
  }
  if (sim.membership) out['MEMBERSHIP_SIM'] = sim.membership
  if (sim.iccid.trim()) out['SERIALE_SIM'] = sim.iccid.trim()
  out[MAIN_PRACTICE_KEY] = String(mainId)
  return out
}
